import { ApolloClient, InMemoryCache, ApolloLink } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

// GraphQL API Endpoint
console.log("REACT_APP_API_URL:", process.env.REACT_APP_API_URL);
const GRAPHQL_ENDPOINT = `${process.env.REACT_APP_API_URL}graphql`;
console.log("GRAPHQL_ENDPOINT:", GRAPHQL_ENDPOINT);

// Create error link factory that accepts a logout callback
export const createErrorLink = (onLogout) => {
  return onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path, extensions }) => {
        console.error(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
        );
        
        // Check if it's an authentication error
        if (extensions?.code === 'UNAUTHENTICATED' || message.includes('Unauthorized') || message.includes('unauthorized')) {
          localStorage.removeItem("accessToken");
          if (onLogout) {
            onLogout();
          }
        }
      });
    }
    if (networkError) {
      console.error(`[Network error]: ${networkError}`);
      if (networkError.statusCode === 401) {
        localStorage.removeItem("accessToken");
        if (onLogout) {
          onLogout();
        }
      }
    }
  });
};

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("accessToken");
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
});
// Upload link for file uploads
const uploadLink = createUploadLink({
  uri: GRAPHQL_ENDPOINT,
});
// Note: errorLink is created dynamically in App.js with the logout callback
// This is just the basic client setup without error handling

// Combine the links (without errorLink for now - it will be added in App.js)
export const createApolloClient = (errorLink) => {
  const link = ApolloLink.from([errorLink, authLink, uploadLink]);
  
  return new ApolloClient({
    link,
    cache: new InMemoryCache({
      typePolicies: {
        Form: {
          keyFields: false,
        },
        Question: {
          keyFields: false,
        },
        UserResponse: {
          keyFields: false,
        },
      },
    }),
  });
};
